import { FC } from "react";
import { Navigate } from "react-router-dom";
import { reportsRoute } from "app/route/Routes";

export const DashboardScreen: FC = () => <Navigate to={reportsRoute.build({})} />;
